import { Quote } from "lucide-react";
import { Reveal } from "@/components/site/motion";
import { TESTIMONIALS } from "@/data/content";

const Testimonials = () => (
  <section id="stories" className="bg-sand py-24 md:py-36 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Reveal className="max-w-3xl mb-16">
        <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Stories of Hope</p>
        <h2 className="font-serif text-4xl md:text-6xl text-forest tracking-tight leading-[1.02]">
          Real lives, genuinely changed
        </h2>
        <p className="mt-5 text-ink2 text-sm italic">Names withheld to protect the privacy of our clients and their families.</p>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.12}>
            <figure className={`h-full rounded-3xl p-8 border ${i === 1 ? "bg-forest text-sand border-forest" : "bg-white border-line"}`}>
              <Quote className={`w-9 h-9 mb-6 ${i === 1 ? "text-sage" : "text-terracotta"}`} />
              <blockquote className={`font-serif text-2xl leading-snug ${i === 1 ? "text-sand" : "text-forest"}`}>
                {`“${t.quote}”`}
              </blockquote>
              <figcaption className="mt-8">
                <p className={`font-semibold ${i === 1 ? "text-sand" : "text-ink"}`}>{t.name}</p>
                <p className={`text-sm ${i === 1 ? "text-sand/60" : "text-ink2"}`}>{t.detail}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
